import { cn } from '@/utils/commonUtil'

import styles from './SectionLabel.module.scss'

type Props = {
  label?: string
  size?: 'sm'
}

export const SectionLabel = ({ label, size }: Props) =>
  label && (
    <span className={cn(styles.container, { size, styles })}>
      <span>{label}</span>
    </span>
  )
